import React from "react";
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { Link } from "react-router-dom";
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Popover from 'react-bootstrap/Popover';
import Rating from "react-rating";
import moment from "moment";
import { getPathList } from './utils';

const LessonItemContent = ({ props, lessonItemState }) => {
    const {
        t,
        lesson,
        IsAdmin,
        type,
        user,
        noBio,
        isFromHome,
        isSmall,
        indices,
        setFavorite,
        remove
    } = props;

    const {
        moreInfo,
        toggleMoreInfo,
        showCopyModal,
        showSendMissionModal,
        showShareModal,
        handleSetIndex,
        openViewWindow,
        openPDFViewWindow,
        copyIdToClipboard
    } = lessonItemState;

    if (!lesson) return null;

    let isFavoriteClass = "far";
    if (lesson.isFavorite === true) {
        isFavoriteClass = "fas text-danger ";
    }
    let initialRating = 0;
    if (lesson.RateCount > 0) {
        initialRating = lesson.Stars / lesson.RateCount;
    }

    const startDate = moment(lesson.CreationDate);
    const timeEnd = moment();
    const diff = timeEnd.diff(startDate);
    const diffDuration = moment.duration(diff);
    const Days = diffDuration.asDays();
    const shareTitle = type === "Games" ? t("Pages.Games.action.share") : t("Pages.Lessons.action.share");
    const displaySkills = lesson.Skills || [];
    const uniqueSkills = Array.from(new Set(displaySkills.map(s => s.SkillName).filter(Boolean)));
    const uniqueTextTypes = Array.from(new Set(displaySkills.map(s => s.TextTypeName).filter(Boolean)));
    const uniqueDimensionComponents = Array.from(new Set(displaySkills.map(s => s.DimensionComponentName).filter(Boolean)));
    const uniqueElements = Array.from(new Set(displaySkills.map(s => s.ElementName).filter(Boolean)));
    const hasSkillsInfo = uniqueSkills.length > 0 || uniqueTextTypes.length > 0 || uniqueDimensionComponents.length > 0 || uniqueElements.length > 0;

    const renderPath = (currentId) => {
        const pathList = getPathList(indices, currentId, 1);
        if (pathList && pathList.length > 0) {
            const length = pathList.length;
            return pathList.map((node, index) => (
                <span key={node.id}>
                    <Link onClick={() => handleSetIndex(node)} to="#">
                        {node.label}
                    </Link>
                    {length !== index + 1 ? <i className="fas fa-arrow-left text-info m-2"></i> : ""}
                </span>
            ));
        }
        return "";
    };

    return (
        <div className={`col-sm ${isSmall === true ? "" : "px-0 mx-1"}`}>
            <div
                className="product-list-item mb-3"
                style={{
                    marginBottom: isSmall === true ? "10px" : "",
                    minHeight: isSmall === true ? "130px" : ""
                }}
            >
                {lesson.IsPublic && (
                    <div
                        className="ribbon-corner ribbon-fold"
                        data-position="left top"
                        style={{
                            fontSize: isSmall === true ? "13px" : "",
                            left: isSmall === true ? "15px" : "",
                        }}
                    >
                        {t("Pages.Lessons.Public")}
                    </div>
                )}
                {lesson.IsActive ? (
                    Days <= 14 ? (
                        <div
                            className="ribbon-corner ribbon-fold"
                            data-position="right top"
                            title={t("New")}
                            style={{
                                right: isSmall === true ? "15px" : "",
                                fontSize: isSmall === true ? "13px" : ""
                            }}
                        >
                            <span className="blink">
                                {t("New")}
                            </span>
                        </div>
                    ) : ""
                ) : (
                    <div className="ribbon-corner ribbon-fold" data-position="right top" title={t("Pages.Lessons.NotActive")}>
                        <i className="fas fa-lock"></i>
                    </div>
                )}

                <div
                    className="product-thumb"
                    style={{
                        height: isSmall === true ? "unset" : "",
                        minHeight: isSmall === true ? "unset" : "",
                        width: isSmall === true ? "35%" : ""
                    }}
                >
                    {lesson.Icon ? (
                        <LazyLoadImage src={lesson.Icon} alt={`${lesson.Name}`} />
                    ) : (
                        <LazyLoadImage src="/assets/images/logo/130p150.png" alt={`${lesson.Name}`} />
                    )}

                    {isSmall !== true && (
                        <div className="product-action-link">
                            <div className="my-1 mr-1" onClick={() => openViewWindow(lesson.Id)} title={t("Pages.Lessons.action.view")}>
                                <i className="far fa-eye"></i>
                            </div>
                            {IsAdmin ? (
                                <>
                                    <Link
                                        className="my-1 mr-1"
                                        to={`/ControlPanel/${!type || type === "Lessons" ? 'Lesson' : type}/Edit/${lesson.Id}`}
                                        title={t("Pages.Lessons.action.edit")}
                                    >
                                        <i className="far fa-edit"></i>
                                    </Link>
                                    <div className="my-1 mr-1" onClick={() => remove && remove(lesson.Id)} title={t("Pages.Lessons.action.remove")}>
                                        <i className="far fa-trash"></i>
                                    </div>
                                    <div className="my-1 mr-1" onClick={() => toggleMoreInfo()} title={t("Pages.Lessons.action.info")}>
                                        <i className="far fa-info"></i>
                                    </div>
                                </>
                            ) : (
                                <>
                                    {setFavorite && (
                                        <div className="my-1 mr-1">
                                            <Link title={t("Favorite")} to="#" onClick={() => setFavorite(lesson.Id)}>
                                                <i className={`${isFavoriteClass} fa-heart`}></i>
                                            </Link>
                                        </div>
                                    )}
                                    {!isFromHome && user && user.user && user.user.UserType && (user.user.UserType.Id === 3 || user.user.UserType.Id === 4) && (
                                        <>
                                            <div className="my-1 mr-1">
                                                <Link title={shareTitle} to="#" onClick={() => showShareModal()}>
                                                    <i className="far fa-mind-share"></i>
                                                </Link>
                                            </div>
                                            <div className="my-1 mr-1">
                                                <Link title={t("Pages.Lessons.action.sendMission")} to="#" onClick={() => showSendMissionModal()}>
                                                    <i className="far fa-bullseye-arrow"></i>
                                                </Link>
                                            </div>
                                        </>
                                    )}
                                </>
                            )}
                        </div>
                    )}
                </div>

                <div
                    className="product-content py-2"
                    style={{
                        padding: isSmall === true ? " 10px 10px 5px 5px" : "",
                        width: isSmall === true ? "65%" : ""
                    }}
                >
                    <h5
                        className="title mb-0"
                        style={{
                            fontSize: isSmall === true ? "18px" : ""
                        }}
                    >
                        <Link
                            to="#"
                            className="text-truncate pt-2 w-100 mb-0 text-center text-md-right"
                            title={lesson.Name}
                            onClick={() => openViewWindow(lesson.Id)}
                        >
                            {lesson.Name}
                        </Link>
                    </h5>

                    <div style={{ fontSize: isSmall === true ? "13px" : "" }}>
                        <Rating
                            initialRating={initialRating}
                            direction="rtl"
                            emptySymbol="far fa-star text-warning"
                            fullSymbol="fas fa-star text-warning"
                            fractions={2}
                            readonly={true}
                        />
                        {isSmall === true ? (
                            <span className="mx-1" title={t("Pages.Lessons.action.ViewCount")}>
                                (<i className="far fa-eye text-warning"></i> {lesson.ViewCount})
                            </span>
                        ) : (
                            <span className="product-view-count">
                                {" "} ( {lesson.RateCount} {t("Pages.Lessons.RateCount")} ,{" "}
                                <span title={t("Pages.Lessons.action.ViewCount")}>
                                    <i className="far fa-eye text-warning"></i> {lesson.ViewCount}
                                </span>{" "} )
                            </span>
                        )}
                    </div>

                    {isSmall !== true && (
                        <h6 className="subtitle d-none d-lg-block">
                            {renderPath(lesson.Index.Id)}
                        </h6>
                    )}

                    {!noBio && (
                        <div className="d-flex justify-content-between align-items-center flex-wrap">
                            <div className="px-1 ml-auto">
                                <div className="d-none d-lg-block">
                                    {lesson.Bio}
                                </div>
                                <div>
                                    {lesson.TotalMark ? (
                                        <span className="ml-3" title={t('Pages.Missions.yourMark')}>
                                            <i className="icon fal fa-tally"></i>
                                            <span className="font-weight-bold ml-1">
                                                <span className={`${(lesson.Mark / lesson.TotalMark * 100) < 50 ? "text-danger" : "text-success"} ml-1`}>
                                                    {lesson.Mark}
                                                </span>
                                                / {lesson.TotalMark}
                                            </span>
                                            (
                                            <span className={`${(lesson.Mark / lesson.TotalMark * 100) < 50 ? "text-danger" : "text-success"} `}>
                                                <span className="font-weight-bold text-dark">%</span>
                                                {Math.round(lesson.Mark / lesson.TotalMark * 100, 2)}
                                            </span>
                                            )
                                        </span>
                                    ) : ""}
                                    {lesson.UserTime && lesson.UserTime.Clock ? (
                                        <span title={t('Pages.Lessons.yourTime')} style={{ direction: 'ltr' }}>
                                            <i className="icon fal fa-user-clock"></i>
                                            {lesson.UserTime.Clock.hour ? (
                                                <span title={t('Pages.Missions.TimeHour.title')}>
                                                    {lesson.UserTime.Clock.hour}
                                                </span>
                                            ) : "00"}
                                            :
                                            {lesson.UserTime.Clock.minutes ? (
                                                <span title={t('Pages.Missions.TimeMinutes.title')}>
                                                    {lesson.UserTime.Clock.minutes >= 10 ? lesson.UserTime.Clock.minutes : "0" + lesson.UserTime.Clock.minutes}
                                                </span>
                                            ) : "00"}
                                            :
                                            {lesson.UserTime.Clock.seconds ? (
                                                <span title={t('Pages.Missions.TimeSeconds.title')}>
                                                    {lesson.UserTime.Clock.seconds >= 10 ? lesson.UserTime.Clock.seconds : "0" + lesson.UserTime.Clock.seconds}
                                                </span>
                                            ) : "00"}
                                        </span>
                                    ) : ""}
                                </div>
                            </div>
                            {IsAdmin && (
                                <>
                                    <Link to="#" className="cate mr-1 btn btn-light" onClick={() => showCopyModal(lesson.Id)} title={t("Pages.Lessons.tools.copy")}>
                                        <i className="fad fa-copy text-default"></i>
                                    </Link>
                                    <Link to="#" className="cate mr-1 btn btn-light" onClick={() => copyIdToClipboard(lesson.Id)} title={t("Pages.Lessons.tools.copyid")}>
                                        <i className="fad fa-clipboard text-success"></i>
                                    </Link>
                                </>
                            )}
                            {lesson.Url && (
                                <Link to="#" className="cate mr-1 btn btn-light" onClick={() => openPDFViewWindow(lesson.Id)} title={t("Pages.Lessons.tools.viewPDF")}>
                                    <i className="fad fa-file-pdf text-primary"></i>
                                </Link>
                            )}
                            {hasSkillsInfo && (
                                <OverlayTrigger
                                    trigger="click"
                                    rootClose
                                    placement="top"
                                    overlay={
                                        <Popover id={`popover-skills-${lesson.Id}`} style={{ direction: 'rtl', textAlign: 'right', maxWidth: '380px' }}>
                                            <Popover.Title as="h3" className="font-weight-bold text-dark">
                                                <i className="fad fa-award text-warning ml-2"></i>
                                                {t("Skills") || "المهارات والمعايير"}
                                            </Popover.Title>
                                            <Popover.Content style={{ maxHeight: '300px', overflowY: 'auto' }}>
                                                <div className="d-flex flex-column" style={{ minWidth: '240px' }}>
                                                    {uniqueSkills.length > 0 && (
                                                        <div className="mb-3">
                                                            <div className="font-weight-bold text-primary mb-1 pb-1 border-bottom small">
                                                                <i className="fad fa-lightbulb text-warning ml-1"></i>
                                                                {t("Skills") || "المهارات"}
                                                            </div>
                                                            {uniqueSkills.map((name, idx) => (
                                                                <div key={`skill-name-${idx}`} className="py-1 px-2 text-dark small">
                                                                    <i className="fas fa-check-circle text-success ml-1" style={{ fontSize: '11px' }}></i>
                                                                    {name}
                                                                </div>
                                                            ))}
                                                        </div>
                                                    )}

                                                    {uniqueTextTypes.length > 0 && (
                                                        <div className="mb-3">
                                                            <div className="font-weight-bold text-info mb-1 pb-1 border-bottom small">
                                                                <i className="fad fa-file-alt text-info ml-1"></i>
                                                                {t("TextTypes") || "أنواع النصوص"}
                                                            </div>
                                                            {uniqueTextTypes.map((name, idx) => (
                                                                <div key={`text-type-${idx}`} className="py-1 px-2 text-dark small">
                                                                    <i className="fas fa-angle-left text-info ml-1" style={{ fontSize: '11px' }}></i>
                                                                    {name}
                                                                </div>
                                                            ))}
                                                        </div>
                                                    )}

                                                    {uniqueDimensionComponents.length > 0 && (
                                                        <div className="mb-3">
                                                            <div className="font-weight-bold text-success mb-1 pb-1 border-bottom small">
                                                                <i className="fad fa-layer-group text-success ml-1"></i>
                                                                {t("DimensionComponents") || "مكونات الأبعاد"}
                                                            </div>
                                                            {uniqueDimensionComponents.map((name, idx) => (
                                                                <div key={`dim-comp-${idx}`} className="py-1 px-2 text-dark small">
                                                                    <i className="fas fa-angle-left text-success ml-1" style={{ fontSize: '11px' }}></i>
                                                                    {name}
                                                                </div>
                                                            ))}
                                                        </div>
                                                    )}

                                                    {uniqueElements.length > 0 && (
                                                        <div className="mb-1">
                                                            <div className="font-weight-bold text-danger mb-1 pb-1 border-bottom small">
                                                                <i className="fad fa-cube text-danger ml-1"></i>
                                                                {t("Elements") || "العناصر"}
                                                            </div>
                                                            {uniqueElements.map((name, idx) => (
                                                                <div key={`elem-${idx}`} className="py-1 px-2 text-dark small">
                                                                    <i className="fas fa-angle-left text-danger ml-1" style={{ fontSize: '11px' }}></i>
                                                                    {name}
                                                                </div>
                                                            ))}
                                                        </div>
                                                    )}
                                                </div>
                                            </Popover.Content>
                                        </Popover>
                                    }
                                >
                                    <button type="button" className="cate mr-1 btn btn-light" title={t("Skills") || "المهارات والمعايير"}>
                                        <i className="fad fa-lightbulb text-warning"></i>
                                    </button>
                                </OverlayTrigger>
                            )}
                        </div>
                    )}
                </div>

                {IsAdmin && moreInfo && (
                    <div
                        className="w-100 pt-2 mt-1 mb-2 px-3 d-flex flex-wrap justify-content-around"
                        style={{ borderTop: '1px dashed #92278f' }}
                    >
                        <div className="text-center">
                            <div className="title">
                                {t("Pages.Lessons.DataEntry")} :
                                <div className="text-secondary">
                                    {lesson.User?.Name}
                                </div>
                            </div>
                        </div>
                        <div className="text-center">
                            <div className="title">
                                {t("Pages.Lessons.CreationDate")} :
                                <div className="text-secondary">
                                    {lesson.CreationDate}
                                </div>
                            </div>
                        </div>
                        <div className="text-center">
                            <div className="title">
                                {t("Pages.Lessons.UpdateDate")} :
                                <div className="text-secondary">
                                    {lesson.UpdateDate}
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default LessonItemContent;
